const chiTieu = () => ({
  chitieu_4_total: {
    width: "100%",
    height: "32vh",
    fontSize: "14px",
    color: "#00ffff",
  },
  chitieu_4_child: {
    width: "100%",
    height: "250px",
    fontSize: "14px",
    marginTop: "20px",
    color: "#00ffff",
  },
  chitieu_4_child_ptm_top: {
    width: "100%",
    height: "250px",
    fontSize: "14px",
    color: "#00ffff",
  },
  chitieu_4_child_ptm: {
    width: "100%",
    height: "250px",
    fontSize: "14px",
    marginTop: "-40px",
    color: "#00ffff",
  },
});

export default chiTieu;
